import { useNavigate, useParams } from "react-router-dom";
import InnerHeader from "../../../../Layouts/InnerHeader";
import Loading from "../../../../Layouts/Loading";
import { fa_date, fa_dateـetime } from "../../../../utils/Persian";
import { useGetSignupByTourQuery } from "../../../../Redux/Apis/ebroApi";
import { useEffect } from "react";

function status_types(type:string) {
    switch (type) {
        case "WAIT":
            return "پرداخت نشده";
        case "SUCCESS":
            return "پرداخت شده";
        case "CANCELLED":
            return "کنسل شده";
        case "EXPIRED":
            return "منقضی شده";
        case "ATTENDED":
            return "شرکت در مسابقه";
        default:
            return type;
    }
}
export default function Signups(){
    let {tourId, tourName} = useParams();
    const navigate = useNavigate()

    useEffect(() => {
        if (!tourId || isNaN(+tourId)) navigate('/ebro-tours')
    })
    
    const {
        data,
        isLoading,
        isSuccess,
    } = useGetSignupByTourQuery(tourId ? +tourId : 0, { refetchOnMountOrArgChange: true })
    
    if(isLoading)
        return <Loading/>

    else if(isSuccess)
        return(
            <div className="container-lg">
                <InnerHeader name={`اسامی ثبت نام شدگان مسابقه: ${tourName ? tourName : ''}`}/>
                <div className="row">
                    {data && data.length > 0 ? 
                    <div className="table-responsive"><table className="table">
                        <thead>
                            <tr>
                            <th scope="col">شناسه</th>
                            <th scope="col">نام و نام خانوادگی</th>
                            <th scope="col">موبایل</th>
                            <th scope="col">تاریخ تولد</th>
                            <th scope="col">کد ملی</th>
                            <th scope="col">شهر</th>
                            <th scope="col">تاریخ ثبت نام</th>
                            <th scope="col">وضعیت</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map((value:any,index:number) => 
                            <tr key={index}>
                                <th scope="row">{value.hash}</th>
                                <td>{value.name}</td>
                                <td>{value.mobile}</td>
                                <td>{fa_dateـetime(value.birthday)}</td>
                                <td>{value.national_num}</td>
                                <td>{value.City.name}</td>
                                <td>{fa_date(value.create_date)}</td>
                                <td className={`${value.status === "SUCCESS" ? "text-success" : "text-danger"}`}>{status_types(value.status)}</td>
                            </tr>
                            )}
                        </tbody>
                    </table></div>
                    :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                            هیچ ثبت نامی نداشته اید
                        </div>
                    </div>
                    }
                </div>
            </div>
        )

    else return <></>
}